import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { journalArticles } from '@/data/journal'
import type { JournalArticle } from '@/types'

interface JournalTeasersProps {
  articles?: JournalArticle[]
}

export function JournalTeasers({ articles }: JournalTeasersProps) {
  const displayArticles = articles && articles.length > 0 ? articles.slice(0, 3) : journalArticles.slice(0, 3)

  return (
    <section className="bg-paper py-24 lg:py-32">
      <div className="mx-auto max-w-content px-6 lg:px-10">
        <div className="mx-auto mb-16 max-w-text-block text-center">
          <p className="mb-4 font-condensed text-xs uppercase tracking-[0.2em] text-wd-orange">The Journal</p>
          <h2 className="font-display text-display-lg lg:text-display-xl font-normal normal-case leading-[0.95]">
            Scent stories
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {displayArticles.map((article, index) => (
            <motion.article
              key={article.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={`/journal/${article.slug}`} className="group block">
                <div className="mb-4 aspect-[3/2] overflow-hidden bg-wd-mist">
                  <img
                    src={article.image}
                    alt={article.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <p className="mb-2 font-condensed text-xs uppercase tracking-[0.15em] text-carbon/50">{article.publishedAt} · {article.readTime} min</p>
                <h3 className="font-display text-2xl normal-case text-carbon transition-colors group-hover:text-wd-orange">
                  {article.title.toLowerCase()}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-carbon/60">{article.excerpt}</p>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}
